import config from "@/config/config";
import { headers } from "./auth.headers";
import { formatQueryString } from "@/helpers/query-string";
import { PaymentAttempt } from "@/domain/payment-attempt.model";
import { IPaginateVueTable } from "@/interfaces/IPaginateVueTable";
import httpClient from "@/helpers/http-client";

export default class PaymentAttemptService {
  private static urlApiBase = config.url_api_base;

  static insert = (data: PaymentAttempt): Promise<PaymentAttempt> => {
    return httpClient
      .request<PaymentAttempt>({
        url: `${this.urlApiBase}/payment-attempt-attempt`,
        method: "POST",
        body: data,
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static update = (data: PaymentAttempt): Promise<PaymentAttempt> => {
    return httpClient
      .request<PaymentAttempt>({
        url: `${this.urlApiBase}/payment-attempt/${data.id}`,
        method: "PATCH",
        body: data,
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static get = (id: string): Promise<PaymentAttempt> => {
    const url = `${this.urlApiBase}/payment-attempt/${id}`;

    return httpClient
      .request<PaymentAttempt>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static list = (
    offset?: number,
    limit?: number,
    order?: string,
    sort?: string,
    filter?: string,
  ): Promise<IPaginateVueTable<PaymentAttempt>> => {
    const query = formatQueryString(offset, limit, order, sort, filter);
    const url = `${this.urlApiBase}/payment-attempt${query}`;

    return httpClient
      .request<IPaginateVueTable<PaymentAttempt>>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static listActive = (): Promise<PaymentAttempt[]> => {
    const url = `${this.urlApiBase}/payment-attempt/list-active`;

    return httpClient
      .request<PaymentAttempt[]>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static delete = (id: string): Promise<PaymentAttempt> => {
    const url = `${this.urlApiBase}/payment-attempt/${id}`;

    return httpClient
      .request<PaymentAttempt>({
        url,
        method: "DELETE",
        headers: headers(),
      })
      .then(result => result?.body);
  };
}
